import { Button, DialogFooter } from "@repo/ui";
import { cn } from "@repo/utils";

type Props = {
  onCancel?: () => void;
  onSave?: () => void;
  disableSave?: boolean;
  loading?: boolean;
};

export const WorkflowsDialogFooter = ({ onCancel, onSave, disableSave, loading }: Props) => {
  const sticky = true;
  return (
    <DialogFooter sticky={sticky} className={cn("!border-0")}>
      <Button
        data-allow-navigation
        size="xl"
        onClick={onCancel}
        variant="outline"
        disabled={loading}
      >
        Cancel
      </Button>
      <Button
        data-allow-navigation
        size="xl"
        onClick={onSave}
        disabled={disableSave || loading}
        loading={loading}
      >
        Save
      </Button>
    </DialogFooter>
  );
};
